import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenTitle,
} from '../AccountScreenContainer';
import { SkeletonLoadingContentLG } from './AccountSkeletonLoading';

export const AccountFavoritesLoading = () => {
  const { formatMessage } = useIntl();

  return (
    <AccountScreenContainer screen="favorites">
      <AccountScreenTitle
        title={formatMessage(messages.accountFavoritesTitle)}
      />

      <AccountScreenSection>
        {/* Favorites */}
        <SkeletonLoadingContentLG />
        <SkeletonLoadingContentLG />
        <SkeletonLoadingContentLG />
        <SkeletonLoadingContentLG />
      </AccountScreenSection>
    </AccountScreenContainer>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountFavoritesTitle: {
    defaultMessage: 'Favorites',
    description: 'Account | Favorites | Title',
  },
});
